import { Button, Text, useDisclosure } from "@chakra-ui/react";
import { Parts, UI } from "components";

export default function Store(props){

    const dialog = useDisclosure()

    return(
    <>
    <Parts.Dialog.Vouchers.Store {...dialog} />

    <UI.Box {...props}>
        <Text children="Comprar vouchers:" color="GrayText" />
        <Button mt={2} colorPalette="purple" onClick={dialog.onOpen}><UI.Icon name="store" /> Abrir loja de vouchers</Button>
    </UI.Box>
    </>
    )
}